import { AlertCircle } from "lucide-react";
import React from "react";

class ErrorThrower extends React.Component<{ message: string }> {
    componentDidMount() {
        throw new Error(this.props.message);
    }

    render() {
        return null;
    }
}

export const TestError = () => {
    const [showError, setShowError] = React.useState(false);
    return (
        <div className="min-h-screen bg-gray-50 p-8">
            {showError && <ErrorThrower message="این یک خطای تست است!" />}
            <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-md overflow-hidden p-6">
                <div className="flex items-center space-x-4 space-x-reverse mb-6">
                    <AlertCircle className="w-8 h-8 text-red-500" />
                    <h2 className="text-2xl font-bold text-gray-900">تست مدیریت خطا</h2>
                </div>

                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                    <p className="text-red-700">
                        این صفحه برای تست عملکرد مدیریت خطا طراحی شده است. با کلیک بر روی دکمه زیر، یک خطای عمدی ایجاد خواهد شد.
                    </p>
                </div>

                <div className="flex justify-center">
                    <button
                        onClick={() => setShowError(true)}
                        className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg 
                                 font-medium transition-colors duration-200 ease-in-out
                                 flex items-center space-x-2 space-x-reverse">
                        <AlertCircle className="w-5 h-5" />
                        <span>ایجاد خطای آزمایشی</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
